import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { BaseComponent, DialogRef } from '@shared/classes';
import { ButtonComponent } from '@shared/components/button/button.component';
import { SubType } from '@shared/constants';
import { DIALOG_DATA, DialogCloseButton, DialogConfig } from '@shared/models';
import {
  SafePipe,
  TransformUrlToBgPipe,
  VariableReplacementPipe,
} from '@shared/pipes';

@Component({
  selector: 'b2c-generic-modal',
  styleUrl: './generic-modal.component.scss',
  templateUrl: './generic-modal.component.html',
  imports: [
    SafePipe,
    ButtonComponent,
    VariableReplacementPipe,
    TransformUrlToBgPipe,
  ],
})
export class GenericModalComponent extends BaseComponent {
  protected readonly dialogConfig = inject<DialogConfig<number>>(DIALOG_DATA);

  private readonly router: Router = inject(Router);
  private readonly dialogRef: DialogRef = inject(DialogRef);

  public SubType: typeof SubType = SubType;
  public closeButtonConfig: DialogCloseButton =
    this.loyaltyChallengeConfig.components.modals.closeButton;

  /**
   * Close DialogRef Reference
   */
  closeDialog(): void {
    this.dialogRef.close();
    if (this.dialogConfig.redirect) {
      this.router.navigate(['login'], {
        queryParams: {
          from: 'missing_token',
        },
        queryParamsHandling: 'merge',
      });
    }
  }
}
